export default "__VITE_ASSET__COaIx__P__"